const IMAGE_WIDTH = 1200;
const IMAGE_HEIGHT = 600;

export default function buildSocialMetaTags({ title, description, image, url, type = 'website', price, currency }) {
  const twitterTags = [{
    property: 'twitter:site',
    content: '@articlemodern',
    vmid: 'twitter:site'
  }];
  const ogTags = [{
    property: 'og:type',
    content: type,
    vmid: 'og:type'
  }];

  if(title) {
    ogTags.push({
      property: 'og:title',
      content: title,
      vmid: 'og:title'
    });
    twitterTags.push({
      property: 'twitter:title',
      content: title,
      vmid: 'twitter:title'
    });
  }

  if(description) {
    ogTags.push({
      property: 'og:description',
      content: description,
      vmid: 'og:description'
    });
    twitterTags.push({
      property: 'twitter:description',
      content: description,
      vmid: 'twitter:description'
    });
  }

  if(image && image.url) {
    const imageUrl = image.url.replace('{width}', IMAGE_WIDTH).replace('{q}', 100);
    twitterTags.push(...[{
      property: 'twitter:card',
      content: 'summary_large_image',
      vmid: 'twitter:card'
    }, {
      property: 'twitter:image',
      content: imageUrl,
      vmid: 'twitter:image'
    }]);
    ogTags.push(...[{
      property: 'og:image',
      content: imageUrl,
      vmid: 'og:image'
    }, {
      property: 'og:image:width',
      content: image.width || `${IMAGE_WIDTH}`,
      vmid: 'og:image:width'
    }, {
      property: 'og:image:height',
      content: image.height || `${IMAGE_HEIGHT}`,
      vmid: 'og:image:height'
    }, {
      property: 'og:image:type',
      content: 'image/jpeg',
      vmid: 'og:image:type'
    }]);

    if(image.alt) {
      ogTags.push({
        property: 'og:image:alt',
        content: image.alt,
        vmid: 'og:image:alt'
      });
    }
  }

  if(url) {
    ogTags.push({
      property: 'og:url',
      content: url,
      vmid: 'og:url'
    });
  }

  if(price && currency) {
    ogTags.push(...[{
      property: 'og:price:amount',
      content: price,
      vmid: 'og:price:amount'
    }, {
      property: 'og:price:currency',
      content: currency,
      vmid: 'og:price:currency'
    }]);
  }

  return [...twitterTags, ...ogTags];
}
